import React, { useContext, useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, Stack, Tooltip } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import UserDetailsContext, { useUserDetails } from "../../context/auth";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from "react-router-dom";
// import "./perfomance.css";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import MaterialSelect from "../../components/MasterSelect";
import Swal from "sweetalert2";
import axios from "axios";


const ManuallyAddedCandidate = () => {
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
 const[rows,setrows]  = useState([])
  const navigate = useNavigate();
 useEffect(()=>{
    fetchdata()
 },[])
  
const fetchdata = async()=>{
    const query =`
    query manuallyAddedCandidates{
  manuallyAddedCandidates{
    id
    jobid
    candidateName
    source
    mobileNumber
    emailid
    cvFile
    department
    screeningStatus
    manuallyAdd
    technicalFeedback {
      id
      hiringStatus
      manuallyAdd
    }
  }
}
    `

    try{
    const res = await axios.post(BASEURL,{
        query,
       
    })
    console.log(res.data.data.manuallyAddedCandidates);
    const row = res.data.data.manuallyAddedCandidates
    setrows(row)
    

    }
    catch(err){
        console.log(err,"error");
        
    }
}


      const hadlerowclick = (e) => {
        // console.log('onWfhListClick:', e?.id, e);
        console.log(e,"roweventt");
        
        if (e?.row?.jobid) {
            navigate(`/recruitment/add-candidate?id=${e?.row?.jobid}`);
        }
    };

    

  const perfomaceListTable = {
    columns: [
    //   {
    //     field: "sno",
    //     headerName: "S.NO",
    //     flex: 1,
    //     editable: false,
    //     disableColumnMenu: true,
    //     sortable: true,
    //   },
      {
        field: "jobid",
        headerName: "JobId",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "candidateName",
        headerName: "CandidateName",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "source",
        headerName: "Source",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "emailid",
        headerName: "Email",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "screeningStatus",
        headerName: "Screening Status",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    //   {
    //     field: "duration",
    //     headerName: "Duration",
    //     flex: 1,
    //     disableColumnMenu: true,
    //     editable: false,
    //     sortable: true,
    //   },
    //   {
    //     headerName: "Action",
    //     field: "action",
    //     name: "Action",
    //     flex: 1,
    //     disableColumnMenu: true,
    //     editable: false,
    //   },
    ],
    rows: []
  };

  const handleNewEvaluation = () => {
    navigate(`/recruitment/add-candidate`);
  };

  

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Manually Added Candidate List
                </MaterialTypography>
              </Stack>

              
              {/* { role?.toLowerCase() == "manager" && (
  <MaterialSelect
    name="selecthr"
    value={selectHr}
    onChange={(e) => handleSelectHrChange(e)}
    options={selecthrOption2?.map((value) => ({
      value: value,
      label: value,
    }))}
  />
)} */}

              
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewEvaluation()}
                  >
                    Add Candidate
                  </MaterialButton>
                
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={rows}
          customHeight={550}
          columns={perfomaceListTable.columns}
          checkboxSelection={false}
          onRowClick={hadlerowclick}
          isSelectable={false}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Manually Added Candidate
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default ManuallyAddedCandidate;
